import storage from '../storage.js'
import store from '../'

const project = {
  namespaced: true,

  state: {
    list: null, // getProjects と同じデータを保存しておく
    application: null
  },

  getters: {
    filteredList:(state) => (application) => {
      let list = []
      if (state.list) {
        if (application === 'KM') {
          list = list.concat(state.list)
        } else {
          list = list.concat(state.list.filter(ele => {
            return ele.application === application
          }))
        }
      }
      return list
    },

    title: (state) => (id) => {
      if(state.list) {
        let prj = state.list.filter(ele => {
          return ele.project_id === id
        })
        return (prj.length > 0) ? prj[0].title : ''
      } else {
        return ''
      }
    }
  },

  actions: {
    // project list を返す
    async getList({state, dispatch, commit,}, application) {
      dispatch('deserialize')
      const hasApp = state.list ? state.list.some(item => item.application == store.state.auth.selectedApplication) : false
      if (!state.list || !hasApp) {
        await store.dispatch('auth/call', {
          api: 'getProjects',
          body: {}
        })
          .then(data => {
            commit('setApplication', application)
            commit('setList', data)
            dispatch('serialize')
          })
          .catch(err => console.log(err))
      }
    },
    // project 名を返す（名前変換用）
    getName({state, dispatch}) {
      dispatch('getList')
      if (!state.list) {
        dispatch('getList')
      }
    },

    addList({commit, dispatch}, data) {
      commit('updateList', data)
      dispatch('serialize')
    },

    serialize({state}) {
      let val = {
        list: state.list,
        application: state.application
      }
      storage.setItem(storage.LocalStorageKeys.project, val)
    },

    deserialize({commit}) {
      let r = storage.getItem(storage.LocalStorageKeys.project)
      if (r) {
        commit('setList', r.list)
        commit('setApplication', r.application)
      } else {
        commit('setList', null)
        commit('setApplication', null)
      }
    },
    // remove（ローカルストレージのprojectを削除する）
    async remove({state, commit, dispatch}, payload) {
      if (!state.list) {
        dispatch('getList', payload.application)
      }
      commit('remove', payload.id)
      dispatch('serialize')
    },

    clear({ commit }) {
      storage.removeAllItems()
      commit('setList', null)
      commit('setApplication', null)
    },
  },

  mutations: {
    // state を変更する
    setList(state, payload) {
      if (payload) {
        if (!state.list) {
          state.list = payload
        } else {
          const apps = payload.map(item => item.application).filter((item, i, self) => self.indexOf(item) === i)
          state.list = state.list.filter(item => {
            return !apps.includes(item.application)
          }).concat(payload)
        }
      } else {
        state.list = payload
      }
    },

    updateList(state, payload) {
      let updated = false
      state.list.forEach((project,index) => {
        if (project.project_id === payload.project_id) {
          state.list.splice(index,1,payload)
          updated = true
        }
      })
      if(!updated) state.list.unshift(payload)

    },
    setApplication(state, payload) {
      state.application = payload
    },
    remove(state, id) {
      state.list.filter( (element, index, array) => {

      })
    }
  }
}
export default project